import { AxiosResponse } from "axios";
import { GetAuthProfileResponse } from "../../../types/api/auth.type";
import httpClient from "../../client/HttpClient";

const AuthService = {
  async login(username: string, password: string): Promise<AxiosResponse> {
    const formData = new FormData();
    formData.append("username", username);
    formData.append("password", password);

    return await httpClient.post<FormData, AxiosResponse>("login", formData, {
      isAuth: false,
      contentType: "multipart/form-data",
    });
  },
  async getProfile(): Promise<GetAuthProfileResponse> {
    return await httpClient.get<GetAuthProfileResponse>("v1/auth/profile", {
      skipUnauthorizedRedirect: true,
    });
  },
  async logout() {
    const response = await httpClient.get("logout");
    return response;
  },
};

export default AuthService;
